__turbopack_context__.v({
  "account": "AccountCard-module__KIzYAq__account",
  "accountNumber": "AccountCard-module__KIzYAq__accountNumber",
  "card": "AccountCard-module__KIzYAq__card",
  "description": "AccountCard-module__KIzYAq__description",
  "details": "AccountCard-module__KIzYAq__details",
  "docs": "AccountCard-module__KIzYAq__docs",
  "dx-tooltip": "AccountCard-module__KIzYAq__dx-tooltip",
  "img": "AccountCard-module__KIzYAq__img",
  "imgPlate": "AccountCard-module__KIzYAq__imgPlate",
  "imgWrapper": "AccountCard-module__KIzYAq__imgWrapper",
  "name": "AccountCard-module__KIzYAq__name",
  "selectedTags": "AccountCard-module__KIzYAq__selectedTags",
  "summaryItem": "AccountCard-module__KIzYAq__summaryItem",
});
